import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AROContent from "./AROPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/aro/pumps" component={AROContent} />
          <Route path="/suppliers/aro">
            <Redirect to="/suppliers/aro/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
